export default class MilestoneModel {

    constructor({id, description, icon, language, year, is_active, created_by, created_by_name}) {
        this.id = id;
        this.keterangan = description;
        this.tahun = year;
        this.language = language;
        this.icon = icon;
        this.status = is_active;
        this.created_by = created_by;
        this.created_by_name = created_by_name;
    }
}